!<template>
  <CardBackground>
    <article class="document-article">
      <div>
        <h1 class="heading heading_size_h1">
          Агентский договор (публичная оферта)
        </h1>
        <p class="body body_size_M text_align_end text_bold">
          «
          <span class="empty-line">
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          »
          <span class="empty-line">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span> 
          2023 г.
        </p>
        <p class="body body_size_M">
          Настоящий Договор адресован неопределенному кругу лиц и является публичной офертой в соответствии с п. 2 ст. 437 ГК РФ. Безусловным акцептом Принципалом настоящего Договора является Регистрация на Сайте https://kazatel.su, путем заполнения Регистрационной формы и проставление отметки “прочитал и согласен с условиями оферты” при заполнении в Личном кабинете реквизитов.
        </p>
        <p class="body body_size_M">
          Настоящий Договор, заключенный путем акцепта настоящей оферты, не требует двустороннего подписания и действителен в электронном виде и вступает в силу с момента его акцепта Принципалом.
        </p>
      </div>
      <section>
        <h2 class="heading heading_size_h2">
          1. Термины и определения
        </h2>
        <p class="body body_size_M">
          1.1. В настоящем агентском договоре, если из текста прямо не вытекает иное, следующие термины будут иметь указанные ниже значения:
        </p>
        <ul>
          <li v-for="therm in thermsList">
            <span class="text_bold">{{ therm[0] }}</span> &mdash; {{ therm[1] }}
          </li>
        </ul>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          2. Предмет Договора
        </h2>
        <p class="body body_size_M">
          2.1. Агент обязуется от имени и за счет Принципала осуществлять: техническую поддержку Плательщиков с целью приобретения ими информационных продуктов (товаров, услуг), размещенных Принципалом на сайте с целью их реализации;
          прием денежных средств от Плательщиков и перечисление Принципалу, а Принципал обязуется уплатить Агенту вознаграждение в размере и в порядке, установленном настоящим Договором.
        </p>
        <p class="body body_size_M">
          2.2. Агент имеет право в любой момент изменять настоящий Договор и все приложения к нему (полностью или в части) в одностороннем порядке, без предварительного согласования с Принципалом. Все изменения вступают в силу на следующий календарный день после размещения на Сайте.
        </p>
        <p class="body body_size_M">
          2.3. Принципал обязуется самостоятельно следить за изменениями настоящего Договора и приложений к нему путем периодического ознакомления с актуальной редакцией. Принципал самостоятельно отвечает за любые последствия, наступившие в связи с не ознакомлением с Договором и приложениями к нему.
        </p>
        <p class="body body_size_M">
          2.4. В случае, если Принципал не согласен с каким-либо положением Договора и (или) приложений к нему, он должен незамедлительно прекратить использование услуг Агента.
        </p>
        <p class="body body_size_M">
          2.5. Принципал самостоятельно определяет состав и содержание информационных продуктов (товаров, услуг), предоставляемых им для просмотра Плательщиками на Платформе. В случае размещения Принципалом на Сайте информационных материалов, продуктов (товаров, услуг), нарушающих законодательство РФ, либо права и интересы (в том числе авторские права) третьих лиц, ответственность за такие нарушения несет, непосредственно, сам Принципал.
        </p>
        <p class="body body_size_M">
          2.6. В случае несогласия Принципала с размером стоимости, установленной Агентом, для просмотра информационного продукта (товара, услуги), размещенного Принципалом на платформе, а также с Размером агентского вознаграждения, Принципал должен незамедлительно прекратить использование услуг Агента.
        </p>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          3. Права и обязанности сторон
        </h2>
        <h3 class="heading heading_size_h3">
          3.1. Права и обязанности Агента:
        </h3>
        <ol class="body body_size_M">
          <li v-for="(text, i) in agentResponsibilityList">
            {{ text }}
            <ul v-if="agentResponsibilitySubList[i]">
              <li v-for="item in agentResponsibilitySubList[i]">
                {{ item }}
              </li>
            </ul>
          </li>
        </ol>
        <h3 class="heading heading_size_h3">
          3.2. Права и обязанности Принципала:
        </h3>
        <ol class="body body_size_M">
          <li v-for="text in userResponsibilityList">
            {{ text }}
          </li>
        </ol>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          4. Вознаграждение и порядок расчетов
        </h2>
        <p class="body body_size_M">
          4.1. Размер агентского вознаграждения, уплачиваемого Принципалом Агенту за исполнение поручений по настоящему Договору, а также Стоимость просмотра Пользователями информационного продукта (товара, услуг), размещенного Принципалом на Платформе, устанавливаются в Приложение № 1 к настоящему Договору «Размер и порядок оплаты агентского вознаграждения, Стоимость просмотра Пользователями информационного продукта (товара, услуги), размещенного Принципалом на Платформе», являющимся неотъемлемой частью настоящего Договора.
        </p>
        <p class="body body_size_M">
          4.2. В случае, если денежных средств, полученных от Плательщиков недостаточно для удержания агентского вознаграждения, Принципал выплачивает вознаграждение в течение 3 (трех) рабочих дней с момента выставления счета. Счет на оплату выставляется посредством Личного кабинета.
        </p>
        <p class="body body_size_M">
          4.3. Принципал не имеет право указывать реквизиты третьего лица для перечисления Агентом причитающихся Принципалу денежных средств.
        </p>
        <p class="body body_size_M">
          4.4. Агент, при его согласии, имеет право переводить денежные средства в валюте, указанной Принципалом (получателем платежа). В таком случае все дополнительные комиссии/сборы за валютный перевод несет Принципал (получатель платежа).
        </p>
        <p class="body body_size_M">
          4.5. Отчет об исполнении Агентом поручения Принципала, представляющий собой историю просмотров Пользователями информационного продукта (товара, услуг), размещенного Принципалом на Платформе, автоматически формируется на Сайте. Агент не направляет отдельные отчеты Принципалу.
        </p>
        <p class="body body_size_M text_italic">
          4.6. Стороны установили, что Принципал считается согласившимся с данными, указанными в отчете Агента, если в течение 3 (трех) календарных дней с момента формирования отчета Агента от Принципала не поступает мотивированных письменных возражений, то отчет Агента считается утвержденным, а агентское поручение исполненным.
        </p>
        <p class="body body_size_M text_italic">
          4.7. Стороны установили, что в случае оформления на Сайте Принципалом запроса на получение денежных средств за отчетный период, в рамках настоящего Договора, Принципал также считается согласившимся с данными, указанными в отчете Агента и отчет Агента считается утвержденным, а агентское поручение исполненным.
        </p>
        <p class="body body_size_M  text_italic">
          4.8. Датой исполнения агентского поручения по настоящему договору считается дата согласования отчета Агента (пункт 4.6 Договора), либо дата запроса Принципала на получение денежных средств, причитающихся ему в рамках настоящего Договора (пункт 4.7 Договора).
        </p>
        <p class="body body_size_M">
          4.9. Датой исполнения обязанности Агента по перечислению денежных средств считается дата списания денежных средств с расчетного счета Агента.
        </p>
        <p class="body body_size_M">
          4.10. Принципал обязуется возместить Агенту денежные суммы, взысканные с Агента платежными системами (кредитными учреждениями) за нарушение Принципалом действующего законодательства, правил международных платежных систем, совершение мошеннических или противоправных действий. Агент имеет право вычесть указанные суммы из сумм, причитающихся Принципалу. В случае, если денежных средств полученных от Покупателей недостаточно для удержания указанных сумм, Принципал возмещает их в течение 5 (пяти) рабочих дней с момента выставления счета. Счет на оплату выставляется посредством Личного кабинета.
        </p>
        <p class="body body_size_M">
          4.11. В случае, если получателем платежа является нерезидент РФ, Агент оставляет за собой права удерживать дополнительные комиссии/сборы.
        </p>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          5. Налогообложение
        </h2>
        <p class="body body_size_M">
          5.1. В связи с тем, что Агент не является для Принципала источником дохода, так как действует от имени и по поручению Принципала, а лицами, от которых Принципал получает доход, являются Плательщики, Агент не является налоговым агентом по отношению к Принципалу и не имеет установленных для налоговых агентов обязанностей по исчислению, удержанию и перечислению в бюджет налога на доходы физических лиц в соответствии со статьей 226 Налогового кодекса Российской Федерации.
        </p>
        <p class="body body_size_M">
          5.2. В соответствии с подпунктом 1 пункта 1 и пунктом 2 статьи 228 Налогового кодекса Российской Федерации на Принципале лежит обязанность по самостоятельному декларированию и уплате налога на доходы физических лиц с доходов. В случае, если Принципал не является гражданином РФ или является нерезидентом РФ, он несет ответственность по уплате налогов и сборов предусмотренным законодательством его гражданской принадлежности.
        </p>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          6. Ответственность Сторон
        </h2>
        <p class="body body_size_M">
          6.1. За неисполнение или ненадлежащее исполнение принятых на себя по настоящему Договору обязательств Стороны несут ответственность в соответствии с действующим законодательством;
        </p>
        <p class="body body_size_M">
          6.2. Агент не несет ответственности перед Пользователями и/или третьими лицами за действия (бездействия) Принципала;
        </p>
        <p class="body body_size_M">
          6.3. Агент не несет ответственность в случае невозможности предоставления Услуги вследствие неисправности программных и аппаратных средств, используемых Агентом и/ или Принципалом и/или Пользователем, а также каналов связи, предоставленных третьими лицами;
        </p>
        <p class="body body_size_M">
          6.4. Агент не несет ответственности за неполучение Принципалом необходимой информации или неполучение ее в оговоренный Договором срок, в связи с техническими проблемами в сети Принципала, а также из-за неполадок в работе Сайта и/или сети и из-за профилактических работ на Сайте;
        </p>
        <p class="body body_size_M">
          6.5. Принципал обязуется возместить Агенту все убытки, возникшие в случае предъявления Пользователями и/или иными лицами каких-либо претензий и/или исков к Агенту, связанных с качеством информационных продуктов (товаров, услуг), размещенных Принципалом, действительностью и условиями или иными обстоятельствами, ответственность за которые несет Принципал. Кроме того, Принципал обязуется от своего имени и за свой счет вести переговоры с предъявившими претензии и/или иски лицами, а также выступать на стороне Агента в суде;
        </p>
        <p class="body body_size_M">
          6.6. Агент не несет никакой ответственности перед Принципалом и/или его Пользователями за какие-либо косвенные/непрямые убытки, включая упущенную выгоду, утрату информации, потерю производства/бизнеса и/или третьих лиц в связи с исполнением Договора, вне зависимости от того, мог ли Агент предвидеть возможность причинения таких убытков;
        </p>
        <p class="body body_size_M">
          6.7. Принципал обязуется возместить Агенту все убытки, возникшие в результате осуществления Агентом возврата Плательщику уплаченных им денежных средств, вызванного признанием платежным агентом Агента и/или кредитной организацией оплаты, совершенной Плательщиком в рамках совершения Сделки, мошеннической транзакцией;
        </p>
        <p class="body body_size_M">
          6.8. Агент не несет ответственности и не возмещает никакие убытки, в том числе никакой ущерб (физический, материальный, моральный), прямой или косвенный, причиненный Принципалу или третьим лицам в результате использования или невозможности использования сервисов Платформы, их отдельных компонентов и/или функций. Также, Агент не несет никакой ответственности перед Пользователями Принципала;
        </p>
        <p class="body body_size_M">
          6.9. Принципал несёт административную, уголовную, материальную ответственность за нарушение действующего законодательства РФ и любые нарушения, повреждения, нанесённый ущерб (материальный, физический, моральный) при размещении на Сайте информационных продуктов (товаров, услуг) перед Пользователями и/или третьими лицами.
        </p>
        <p class="body body_size_M">
          6.10. Принципал несет ответственность перед Агентом за правильность и достоверность предоставляемых данных, информации и сведений.
        </p>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          7. Форс-мажор
        </h2>
        <p class="body body_size_M">
          7.1. Стороны освобождаются от ответственности за частичное и/или полное неисполнение обязательств по настоящему Договору, если такое неисполнение явилось следствием наступления чрезвычайных и непредотвратимых при данных условиях обстоятельств непреодолимой силы, которые Стороны не могли ни предвидеть, ни предотвратить разумными мерами и если эти обстоятельства непосредственно повлияли на исполнение настоящего Договора и возникли после его заключения (форс-мажор). При этом срок исполнения обязательств по настоящему Договору отодвигается соразмерно времени, в течение которого действовали такие обстоятельства, а также вызванные ими последствиями;
        </p>
        <p class="body body_size_M">
          7.2. К обстоятельствам непреодолимой силы относятся: землетрясения, наводнения, пожары, аварии на транспорте, мятежи, гражданские беспорядки, война и военные действия, публикация нормативных актов запрещающего характера, объявление дефолта в экономической ситуации в стране, а также другие события, находящиеся вне разумного предвидения и контроля Сторон. Сторона, для которой создалась невозможность исполнения обязательств по настоящему Договору вследствие наступления вышеназванных обстоятельств, обязана известить в письменной форме другую Сторону без промедления, но не позднее 7 (семи) рабочих дней с даты их наступления. Извещение должно содержать данные о наступлении и характере обстоятельств и возможных их последствиях. Наступление обстоятельств непреодолимой силы должно быть документально подтверждено уполномоченным государственным органом;
        </p>
        <p class="body body_size_M">
          7.3. Не извещение и/или ненадлежащее извещение другой Стороны Стороной, для которой создалась невозможность исполнения обязательств вследствие наступления обстоятельств непреодолимой силы, влечет за собой утрату для этой Стороны права ссылаться на такие обстоятельства в качестве оснований, освобождающих ее от ответственности по настоящему Договору;
        </p>
        <p class="body body_size_M">
          7.4. Если период действия обстоятельств непреодолимой силы превысит 2 (два) месяца, любая из Сторон будет иметь право расторгнуть настоящий Договор.
        </p>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          8. Разрешение споров
        </h2>
        <p class="body body_size_M">
          8.1. Договор и все возникающие из него правоотношения регулируются законодательством Российской Федерации. Все возникающие споры разрешаются на основании законодательства Российской Федерации;
        </p>
        <p class="body body_size_M">
          8.2. Все споры, разногласия и претензии, которые могут возникнуть в связи с исполнением, расторжением или признанием недействительным Договора, Стороны будут стремиться решить путем переговоров. Сторона, у которой возникли претензии и/или разногласия, направляет другой Стороне сообщение с указанием возникших претензий и/ или разногласий;
        </p>
        <p class="body body_size_M">
          8.3. В течение 15 (пятнадцати) рабочих дней с момента получения, указанного в пункте 8.2 Договора, сообщения Сторона, получившая его, обязана направить ответ на это сообщение;
        </p>
        <p class="body body_size_M">
          8.4. В случае если ответ на сообщение не будет получен направившей сообщение Стороной в течение 30 (тридцати) календарных дней с даты направления соответствующего сообщения, либо если Стороны не придут к соглашению по возникшим претензиям и/или разногласиям, спор подлежит передаче на рассмотрение в Арбитражный суд города Москвы, либо в суд общей юрисдикции по месту нахождения Агента.
        </p>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          9. Конфиденциальность
        </h2>
        <p class="body body_size_M">
          9.1. Факт заключения Договора не рассматривается Сторонами как конфиденциальная информация.
        </p>
        <p class="body body_size_M">
          9.2. Не является нарушением конфиденциальности предоставление конфиденциальной информации по законному требованию правоохранительных или иных уполномоченных государственных органов и должностных лиц в случаях и в порядке, предусмотренных применимым законодательством Российской Федерации.
        </p>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          10. Заключительные положения
        </h2>
        <p class="body body_size_M">
          10.1. Настоящий Договор вступает в силу с момента его акцепта Принципалом и действует в течение года. Если в течение 30 (тридцати) календарных дней до истечения указанного срока ни одна из Сторон не заявит письменно о прекращении настоящего Договора, последний считается пролонгированным каждый раз на новый срок, равный одному году на прежних условиях;
        </p>
        <p class="body body_size_M">
          10.2. Агент имеет право на отзыв оферты в соответствии со ст. 436 ГК РФ. В случае отзыва настоящего Договора Агентом в течение срока его действия, настоящий Договор считается прекращенным с момента отзыва. Отзыв осуществляется путем размещения соответствующей информации на Сайте.
        </p>
        <p class="body body_size_M">
          10.3. В случае расторжения Договора в одностороннем внесудебном порядке по инициативе одной из Сторон, Сторона изъявившая желание расторгнуть Договор обязана направить другой Стороне письменное уведомление о расторжении за 10 (десять) календарных дней до даты планируемого расторжения.
        </p>
        <p class="body body_size_M">
          10.4. Все вопросы, не урегулированные Договором или урегулированные не полностью, регулируются законодательством Российской Федерации.
        </p>
        <p class="body body_size_M">
          10.5. Недействительность одного или нескольких пунктов настоящей Оферты, если такая недействительность будет установлена судом, не влечет недействительности настоящей Оферты.
        </p>
      </section>
      <section>
        <h2 class="heading heading_size_h2">
          11. Реквизиты Агента
        </h2>
        <p class="body body_size_M">
          <pre>
Общество с ограниченной ответственностью
«Национальный Центр Консалтинга и Экспертизы»
Адрес: 125047, г. Москва, 1-я Тверская-Ямская улица., д. 29, стр. 1, помещ. 3/2.
ИНН 6166061055/ КПП 771001001
ОГРН 1076166001581
Банковские реквизиты:
р/с 40702810838000249946
в ПАО СБЕРБАНК
г. Москва
к/с 30101810400000000225
БИК 044525225
          </pre>
        </p>
      </section>
    </article>
    <article class="document-article" style="margin-top: 128px;">
      <div class="application-header">
        <p class="text_align_end">
          Приложение №1
        </p>
        <p class="text_align_end">
          к Агентскому договору (публичной оферте)
        </p>
        <p class="text_align_end">
          от «
          <span class="empty-line">
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          »
          <span class="empty-line">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span> 
          2023 г.
        </p>
      </div>
      <h2 class="heading heading_size_h2" style="text-align: center;">
        «Размер и порядок оплаты агентского вознаграждения,
        Стоимость просмотра Пользователями информационного продукта (товара, услуги), размещенного Принципалом на Платформе»
      </h2>
      <table class="table">
        <thead>
          <tr>
            <th style="width: 35%"></th>
            <th>единица измерения</th>
            <th>стоимость</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Агентское вознаграждение</th>
            <td>1 просмотр (клик)</td>
            <td>0 руб.</td>
          </tr>
          <tr>
            <th>
              Стоимость просмотра Пользователями информационного продукта (товара, услуг), размещенного Принципалом на Платформе
            </th>
            <td>1 просмотр (клик)</td>
            <td>0.01 руб.</td>
          </tr>
        </tbody>
      </table>
    </article>
  </CardBackground>
</template>

<script>
import CardBackground from '@/components/UI/card/CardBackground.vue';


export default {
  name: 'agent-oferta-doc',

  components: {
    CardBackground,
  },

  data() {
    return {
      thermsList: [
        [
          'Агент',
          'Общество с ограниченной ответственностью «Национальный центр консалтинга и экспертизы» (ООО «НЦК») - юридическое лицо, зарегистрированное по законодательству Российской Федерации, ОГРН 1076166001581, находящееся по адресу Российская Федерация, 125047, г. Москва, 1-я Тверская-Ямская улица., д. 29, стр. 1, помещ. 3/2.'
        ],
        [
          'Договор',
          'Настоящий агентский договор.'
        ],
        [
          'Платформа (Сайт)',
          'интернет-ресурс https://kazatel.su.'
        ],
        [
          'Услуги (Услуга)',
          'предоставление Пользователю (Плательщику) информационно-консультационных услуг в виде доступа к информационным материалам Платформы в том числе в виде доступа к информационным продуктам (товарам, услугам), размещенным Принципалом на Платформе.'
        ],
        [
          'Принципал',
          'сторона настоящего Договора (физическое лицо, индивидуальный предприниматель, самозанятый), осуществляющая дистанционную торговлю информационными товарами (услугами), совершившая акцепт в установленном порядке, получающая денежные средства Плательщика за реализуемые информационные товары (услуги).'
        ],
        [
          'Личный кабинет',
          'закрытая часть Сайта, доступ к которой осуществляется Принципалом путем ввода логина и пароля, полученного при Регистрации на Сайте.'
        ],
        [
          'Регистрация',
          'заполнение Принципалом Регистрационной формы, расположенной на Сайте, путем указания необходимых сведений и выбора Логина и пароля.'
        ],
        [
          'Регистрационная форма',
          'форма, расположенная на Сайте, которую Принципал должен заполнить для прохождения Регистрации на Сайте.'
        ],
        [
          'Плательщик (Пользователь)',
          'лицо, приобретающее информационный продукт (товар, услугу), размещенный Принципалом на Платформе, путем его просмотра на Платформе Агента и оплачивающее его посредством сервиса Агента.'
        ],
        [
          'Отчетный период',
          'три календарных месяца.'
        ]
      ],

      agentResponsibilityList: [
        '3.1.1. Агент обязуется вести учет количества просмотров Пользователями информационных продуктов (товаров, услуг), размещенного Принципалом на платформе и, соответственно, вести учет денежных средств, причитающихся Принципалу;',
        '3.1.2. Агент обязуется своевременно перечислять на расчетный счет Принципала денежные средства, принятых от Плательщиков в порядке, установленным разделом 4 настоящего Договора;',
        '3.1.3. Агент обязан осуществлять техническую поддержку Плательщиков по вопросам, связанным с осуществлением платежей и приобретению информационных продуктов (товаров, услуг), размещенного Принципалом на Платформе.',
        '3.1.4. Агент вправе в случае возникновения обстоятельств, не зависящих от Сторон, которые могут по мнению Агента повлечь значительные убытки для Агента, приостановить доступ к услугам Сайта на срок действия таких обстоятельств;',
        '3.1.5. Агент вправе привлекать других лиц – субагентов - для осуществления приема платежей физических лиц (Плательщиков) в целях исполнения поручений Принципала по настоящему договору;',
        '3.1.6. Удерживать из денежных средств, оплаченных Плательщиками и поступивших на счет Агента свое вознаграждение и сумму понесенных расходов, связанных с исполнением обязательств по настоящему Договору;',
        '3.1.7. В одностороннем порядке приостановить оказание услуг по настоящему Договору и расторгнуть Договор, в случае нарушения Принципалом обязательств и условий настоящего Договору, а также из-за:',
      ],

      agentResponsibilitySubList: {
        6: [
          '- неисправности средств связи и доступа к Сайту, принадлежащих Принципалу;',
          '- в случае любого обмана (предоставления недостоверных данных) Агента Принципалом.',
        ]
      },

      userResponsibilityList: [
        '3.2.1. Принципал обязуется своевременно и полностью выплачивать Агенту вознаграждение в размере и порядке, установленном разделом 4 Договора;',
        '3.2.2. Принципал обязуется предоставлять Агенту всю необходимую информацию для исполнения обязательств по настоящему Договору;',
        '3.2.3. Принципал обязуется своевременно информировать обо всех существенных изменениях, влияющих на исполнение Договора;',
        '3.2.4. Не передавать третьим лицам пароли и логины, используемые для доступа к Сайту, обеспечивать их конфиденциальность. Все действия, совершенные с использованием полученного логина и пароля, считаются совершенными Принципалом, и ответственность за такие действия несет Принципал.',
      ]
    }
  }
}
</script>

<style scoped>
@import url('./styles.css');


.empty-line {
  text-decoration: underline;
}

th, td {
  border: 1px solid black;
  text-align: center;
  font-weight: bold;
}
</style>
